// project-imports
import { deleteRequest, getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - DT DEVELOPMENTS ||============================== //

export async function handleDTDevelopments(action: APIAction) {
  switch (action.method) {
    case 'read':
      return getRequest(`/dt-developments?dt-id=${action.id}`);
    case 'read-developments':
      // return postRequest(`/dt-developments/developments?t-id=${action.id}`, action.data);
      return postRequest('/dt-developments/developments', action.data);
    case 'create':
      return postRequest('/dt-developments', action.data);
    case 'update':
      return putRequest(`/dt-developments/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/dt-developments/${action.id}`);
    default:
      console.info('[ApiManager > handleApiAction > handleDTDevelopments] - Unknown method');
      break;
  }
}
